import * as Type from 'library/ts/utilities/modules/Type';
export const hasClass = (element, className) => {
    if (Type.isNull(element.getAttribute('class')) === true)
        return false;
    if (element.classList) {
        return element.classList.contains(className);
    }
    else {
        return (element.getAttribute('class').indexOf(className) !== -1);
    }
};
export const addClass = (element, className) => {
    if (Type.isElement(element) === false)
        return;
    if (element.classList) {
        element.classList.add(className);
    }
    else if (!hasClass(element, className)) {
        element.setAttribute('class', (element.getAttribute('class') + ' ' + className));
    }
};
export const removeClass = (element, className) => {
    if (Type.isElement(element) === false)
        return;
    if (element.classList) {
        element.classList.remove(className);
    }
    else if (hasClass(element, className)) {
        const classes = element.getAttribute('class').replace(className, ' ');
        element.setAttribute('class', classes.trim());
    }
};
export const toggleClass = (condition, element, className) => {
    if (Type.isElement(element)) {
        condition ? addClass(element, className) : removeClass(element, className);
    }
};
export const toggleBreakpoint = (rect, elements, breakpoints) => {
    if (Type.isArray(elements) && !Type.isEmpty(elements) && Type.isArray(breakpoints) && !Type.isEmpty(breakpoints)) {
        breakpoints.forEach((breakpoint) => {
            const { minWidth, maxWidth, minHeight, maxHeight } = breakpoint;
            const meetsMinWidth = !minWidth || minWidth <= rect.width;
            const meetsMaxWidth = !maxWidth || maxWidth >= rect.width;
            const meetsMinHeight = !minHeight || minHeight <= rect.height;
            const meetsMaxHeight = !maxHeight || maxHeight >= rect.height;
            const toggle = meetsMinWidth && meetsMaxWidth && meetsMinHeight && meetsMaxHeight;
            elements.forEach((el) => {
                if (Type.isElement(el)) {
                    toggleClass(toggle, el, breakpoint?.className);
                }
            });
        });
    }
};
export const removeClasses = (element, classes) => {
    classes = classes.trim();
    let classesProcessed;
    classes.indexOf(' ') > -1 ? classesProcessed = classes.split(' ') : classesProcessed = [classes];
    for (let i = 0; i < classesProcessed.length; i++) {
        if (hasClass(element, classesProcessed[i]))
            removeClass(element, classesProcessed[i]);
    }
};
export const removeClassesWithSubstring = (element, substring) => {
    let classes = element.className.trim();
    classes.indexOf(' ') > -1 ? classes = classes.split(' ') : classes = [classes];
    for (let i = 0; i < classes.length; i++) {
        if (classes[i].indexOf(substring) > -1)
            removeClass(element, classes[i]);
    }
};
export const removeAllClasses = (element) => {
    element.className = '';
};
export const setElementSelected = (value, elements, valueAttribute = 'value', selectionClass = 'selected') => {
    for (let i = 0; i < elements.length; i++) {
        if (elements[i].getAttribute(valueAttribute) === value) {
            addClass(elements[i], selectionClass);
        }
        else {
            removeClass(elements[i], selectionClass);
        }
    }
};
export const selectInputElementByCssClass = (cssClass = undefined, nodeList = undefined) => {
    if (Type.isUndefined(cssClass))
        return;
    if (Type.isEmptyString(cssClass))
        return;
    if (Type.isDefined(nodeList)) {
        for (let i = 0; i < nodeList.length; i++) {
            nodeList[i].checked = hasClass(nodeList[i], cssClass);
        }
    }
};
export const addCSSRule = (sheet, selector, rules) => {
    let index = sheet.cssRules.length - 1;
    for (let i = index; i > 0; i--) {
        const current_style = sheet.cssRules[i];
        if (current_style.selectorText === selector) {
            rules = current_style.style.cssText + rules;
            sheet.deleteRule(i);
            index = i;
        }
    }
    if (sheet.insertRule) {
        sheet.insertRule(selector + '{' + rules + '}', index);
    }
    else {
        sheet.addRule(selector, rules, index);
    }
    return sheet.cssRules[index].cssText;
};
export const injectCSS = (cssRules, parent = 'head', divID = 'smart-tag-injected-css') => {
    switch (parent) {
        case 'head':
            const style = document.createElement('style');
            style.type = 'text/css';
            style.innerHTML = cssRules;
            document.getElementsByTagName('head')[0].appendChild(style);
            break;
        case 'body':
            const wrap = document.createElement('div');
            const temp = document.createElement('div');
            if (!wrap.id) {
                wrap.id = divID;
                wrap.style.display = 'none';
                document.body.appendChild(wrap);
            }
            temp.innerHTML = '<br><style>' + cssRules + '</style>';
            wrap.appendChild(temp.children[1]);
            break;
    }
};
export const removeInlineStyleProperty = (element, property) => {
    if (element.style.removeProperty) {
        element.style.removeProperty(property);
    }
    else {
        element.style.removeAttribute(property);
    }
};
export const setInlineStyleProperty = (element, property, value, important = false) => {
    if (Type.isElement(element)) {
        if (Type.isEmptyString(property))
            return;
        if (Type.isEmptyString(value) || Type.isUndefined(value))
            return;
        element.style.setProperty(property, value, (important === true ? 'important' : undefined));
    }
};
export const ccTransitionInline = (property, duration, timingFunction, delay) => {
    const vendors = ['-webkit-', '-moz-', '-o-', '-ms-', ''];
    let out = '';
    for (let i = 0; i < vendors.length; i++) {
        out += vendors[i] + 'transition:';
        out += ' ';
        out += property || 'all';
        out += ' ';
        out += duration || '0.2s';
        out += ' ';
        out += timingFunction || 'ease';
        out += ' ';
        out += delay || '0s';
        out += ';';
    }
    return out;
};
export const setCSS3Style = (element, property, value) => {
    const vendors = ['-moz-', '-webkit-', '-o-', '-ms-', '-khtml-', ''];
    const toCamelCase = (str) => {
        return str.toLowerCase().replace(/(\-[a-z])/g, ($1) => {
            return $1.toUpperCase().replace('-', '');
        });
    };
    for (let i = 0, l = vendors.length; i < l; i++) {
        element.style[toCamelCase(vendors[i] + property)] = value;
    }
};
export const cStyle = (element, pel = undefined) => {
    return window.getComputedStyle(element, (pel || null));
};
export const offset = (element) => {
    const rect = element.getBoundingClientRect();
    return {
        top: rect.top + document.body.scrollTop,
        left: rect.left + document.body.scrollLeft
    };
};
export const whichTransitionEvent = () => {
    if (!Type.isFunction(document?.createElement)) {
        return null;
    }
    const fakeElement = document.createElement('fakeelement');
    const transitions = {
        'transition': 'transitionend',
        'OTransition': 'oTransitionEnd',
        'MozTransition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd'
    };
    for (const key in transitions) {
        if (fakeElement.style[key] !== undefined) {
            return transitions[key];
        }
    }
    return null;
};
export const stringToClassSelector = (cssClassString = '') => {
    let output = cssClassString.split(' ').join('.');
    if (Type.isString(output) && output.length > 0 && output.charAt(0) !== '.') {
        output = `.${output}`;
    }
    return output.length > 1 ? output : undefined;
};
export const inlineOpacityHide = (elements) => {
    return new Promise((resolve, reject) => {
        elements.forEach((element) => {
            if (Type.isElement(element)) {
                element.style.setProperty('opacity', '0', 'important');
            }
        });
        resolve({ msg: 'Done.' });
    });
};
export const inlineOpacityRemove = (elements) => {
    return new Promise((resolve, reject) => {
        elements.forEach((element) => {
            if (Type.isElement(element)) {
                element.style.removeProperty('opacity');
            }
        });
        resolve({ msg: 'Done.' });
    });
};
